import { render, staticRenderFns } from "./EmployeePenaltiesAndRewards.vue?vue&type=template&id=58819316"
import script from "./EmployeePenaltiesAndRewards.vue?vue&type=script&lang=js"
export * from "./EmployeePenaltiesAndRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports